// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--1Y0Om","active":"navigation-module--active--1iM01"};